import { render } from "./AllGenres.vue?vue&type=template&id=cbf2a79e"
import script from "./AllGenres.vue?vue&type=script&lang=js"
export * from "./AllGenres.vue?vue&type=script&lang=js"

import "./AllGenres.vue?vue&type=style&index=0&id=cbf2a79e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__